import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsInt, IsObject, IsOptional, IsString, Max, Min, ValidateNested } from 'class-validator';
import { WebStoreExposeGroup } from '../interface';
import { ReadWebStoreThemePromotionsBarDto } from './ReadWebStoreThemePromotionsBarDto';
import { ReadWebStoreThemeSubscriptionDto } from './ReadWebStoreThemeSubscriptionDto';
export class ReadWebStoreMetadataThemeDto {
}
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "mainColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "textBase", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "textGradient", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "notificationBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "notificationColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "ffBase", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "ffSecondary", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "mainHoverColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "navWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "grayColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "grayColor2", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "titleStyle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "titlesTransform", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "titlesWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuPosition", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "usernameColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "cartHeaderCountBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "cartHeaderCountColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerBannerBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerBannerColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerHeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "navColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "navColorMobile", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "logoSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "logoWidth", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "logoHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "mobileLogoWidth", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "mobileLogoHeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "buttonBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "buttonBgHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "buttonColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "buttonColorHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "mainBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "mainBgMobile", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "modalPromotionColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "modalTitleColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "navBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "navColorHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "navUnderline", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "ffHeader", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerTextTransform", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "toastSuccessBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "toastSuccessColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "letterSpacing", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "checkboxCheckedColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "ffHeroBlockTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockTitleFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockTitleFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "ffHeroBlockDescription", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categoryWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categoryTitleFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categoryTitleFontSizeDesktop", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categoryColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categoryTitleTextAlignMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "backgroundCategory", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitleBackground", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categoryTitleTextGradient", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categoryTitlePadding", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categoryTitlePaddingDesktop", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitleColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitleFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitleFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitleFontStyle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitleFontFamily", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitleTextTransform", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitlePadding", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "categorySubtitlePaddingDesktop", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockDescriptionFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockBannerRatio", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockContentAlign", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockJustifyContent", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockMargin", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockTextAlign", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockTextColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockLineHeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockBannerBrightness", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockPlainTextFF", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockBackgroundMobile", void 0);
__decorate([
    ApiProperty({ type: () => String, default: 'auto' }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockMobileHeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexFontStyle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexMargin", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleFF", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleFontStyle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleMargin", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysTextTransform", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysFontStyle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleHoursFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleHoursFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroBlockScheduleHoursColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "heroblockBannerHeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemBorder", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemBorderColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemBorderHoverColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemBackgroundColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemBoxShadow", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemBoxShadowHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontFamily", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontSizeDesktop", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontWeightDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontFamilyDesktop", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuTextTransform", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuTextFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "backCustomButtonFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "clearCartCustomButtonFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemDescriptionFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemDescriptionFontSizeMobile", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemDescriptionFontStyle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemDescriptionTextAlign", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemIngredientsFF", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemIngredientsFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemIngredientsFontStyle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemIngredientsFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemIngredientsColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemIngredientsTextTransform", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemPriceFontStyle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemPriceTextTransform", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerNavHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "titlesTransformTopCategories", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemCardHeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "ffTopCategories", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "topCategoriesTextGradient", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "ffStoreItemMainTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "footerBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "footerTextColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemTitleTextAlign", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemTitleColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemTextGradient", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemTitleSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemPriceAlign", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupAlign", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "usernameFontWeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "usernametextTransform", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "titlesTransformItemMainTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerCustomButtonBg", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerCustomButtonBgHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerCustomButtonColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerCustomButtonColorHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "headerCustomButtonFontSize", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "ffStoreItemMainSubtitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "addonsValidateColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "addonsSelectionColor", void 0);
__decorate([
    ApiProperty({ type: ReadWebStoreThemePromotionsBarDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Type(() => ReadWebStoreThemePromotionsBarDto),
    __metadata("design:type", ReadWebStoreThemePromotionsBarDto)
], ReadWebStoreMetadataThemeDto.prototype, "promotionsBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "orderTotalInfoBoxFontSize", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    IsDefined({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "orderTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Array)
], ReadWebStoreMetadataThemeDto.prototype, "fontSoruces", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "itemDescriptionFormat", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "headerTopNavBar", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "socialMedia", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "orderToTable", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "loyaltyHeaderColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemTitleLetterSpacing", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemDescriptionLetterSpacing", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemDescriptionLineHeight", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemImageBorderRadiusMobile", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemImageBorderRadiusDesktop", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemBackgroundColorMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemImageWidthMobile", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "chevronBackgroundColorTopSellingScrollMenu", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "sliderDotsItemActiveColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "sliderDotsItemColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "chevronColorTopSellingScrollMenu", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "storeitemImageWidthDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemModifierGroupCardBorderColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemModifierGroupRequiredTextColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemModifierGroupBadgeTextColorActive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemModifierGroupBadgeTextColorInactive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemModifierGroupBadgeBackgroundActive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "itemModifierGroupBadgeBackgroundInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuVerticalGap", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuVerticalGapDesktop", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuHorizontalGap", void 0);
__decorate([
    ApiProperty({ type: () => String, default: '8px' }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "mobileMenuHorizontalGap", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsInt({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Min(2, { always: true }),
    Max(5, { always: true }),
    __metadata("design:type", Number)
], ReadWebStoreMetadataThemeDto.prototype, "menuColumnsNumberDesktop", void 0);
__decorate([
    ApiProperty({ type: () => Number, default: 1 }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsInt({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Min(1, { always: true }),
    Max(2, { always: true }),
    __metadata("design:type", Number)
], ReadWebStoreMetadataThemeDto.prototype, "menuColumnsNumberMobile", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuItemsAlign", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuItemsOneRowAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataThemeDto.prototype, "menuItemsDivider", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "orderStatusBanner", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "discount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "loyaltyDisclaimer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "loyaltyBadge", void 0);
__decorate([
    ApiProperty({ type: ReadWebStoreThemeSubscriptionDto }),
    Type(() => ReadWebStoreThemeSubscriptionDto),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", ReadWebStoreThemeSubscriptionDto)
], ReadWebStoreMetadataThemeDto.prototype, "subscription", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "orderReminder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "menuConcepts", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "navigationBar", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "navigationBarItemHover", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "navigationBarItemActive", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "navigationBarMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "menuListCategorySchedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "menuListItemSchedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "itemScheduleBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "itemModalScheduleBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "menuList", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "modal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "prepTimeBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "multiBrandCartBox", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataThemeDto.prototype, "prepTimeCartBlock", void 0);
//# sourceMappingURL=ReadWebStoreMetadataThemeDto.js.map